// CookReviseOffer — post-cook interstitial shown AFTER the XP summary
// when the cook left notes. The notes ("too spicy", "pan wasn't hot
// enough") are exactly the feedback the AI revise flow wants — this
// screen turns them into a one-tap seed instead of asking the user to
// re-type them later.
//
// PAID-AI discipline, twice over: this screen fires nothing — the tap
// only OPENS RecipeReviseSheet pre-filled; the AI call happens on the
// sheet's own explicit button.

import { FONT, COLOR } from "../lib/tokens";

export default function CookReviseOffer({ recipeTitle, notes, onRevise, onSkip }) {
  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", padding: "40px 24px 32px" }}>
      <div style={{ fontFamily: FONT.mono, fontSize: 12, color: COLOR.gold, letterSpacing: "0.15em", marginBottom: 8 }}>
        FOR NEXT TIME
      </div>
      <h2 style={{ fontFamily: FONT.serif, fontSize: 26, fontWeight: 300, fontStyle: "italic", color: COLOR.ink, marginBottom: 8 }}>
        Want {recipeTitle ? `"${recipeTitle}"` : "this recipe"} to learn from tonight?
      </h2>
      <p style={{ fontFamily: FONT.sans, fontSize: 13, color: COLOR.muted, lineHeight: 1.55, marginBottom: 18 }}>
        Your notes can become a revised version — reviewed by you
        before anything saves.
      </p>

      <div style={{
        padding: "12px 14px", background: COLOR.ground,
        border: `1px solid ${COLOR.border}`, borderRadius: 12,
        fontFamily: FONT.serif, fontStyle: "italic", fontSize: 15,
        color: COLOR.ink, lineHeight: 1.5, marginBottom: 22,
      }}>
        "{notes}"
      </div>

      <button
        type="button"
        className="mcm-focusable"
        onClick={onRevise}
        style={{
          width: "100%", padding: "15px",
          background: COLOR.leaf, border: "none", borderRadius: 14,
          fontFamily: FONT.mono, fontSize: 13, fontWeight: 600,
          color: COLOR.night, letterSpacing: "0.08em",
          cursor: "pointer", touchAction: "manipulation",
        }}
      >
        REVISE FOR NEXT TIME →
      </button>
      <button
        type="button"
        className="mcm-focusable"
        onClick={onSkip}
        style={{
          marginTop: 10, width: "100%", padding: "13px",
          background: "transparent", border: `1px solid ${COLOR.border}`,
          borderRadius: 12, fontFamily: FONT.mono, fontSize: 12,
          color: COLOR.dim, letterSpacing: "0.08em",
          cursor: "pointer", touchAction: "manipulation",
        }}
      >
        NOT NOW
      </button>
    </div>
  );
}
